import React from 'react';
import { withStyles, StyledComponentProps } from '@material-ui/core';
import { styles } from './styles';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
require('moment/locale/it.js');

interface IProps extends StyledComponentProps {
    label?: string;
    value: string | { hours: number, minutes: number };
    onChange: (hours: number, minutes: number) => any;
    onBlur?: (val: string) => any;
    placeholder?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    className?: any;
}

const TextField = (props: IProps) => {
    // const { classes, ...otherProps } = props;

    return (
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale='it'>
            <KeyboardTimePicker className={props.className}
                label={props.label}
                fullWidth={props.fullWidth}
                format={'HH:mm'}
                color="secondary"
                ampm={false}
                disabled={props.disabled}
                placeholder={props.placeholder}
                mask="__:__"
                value={parseValue(props.value)}
                onChange={date => { props.onChange(date ? date.hours() : undefined, date ? date.minutes() : undefined) }}
            />
        </MuiPickersUtilsProvider>

    );
}

// const parseTimePart = (dt: Date) => {
//     const m = moment(dt);
//     return {
//         hours: m.hours(),
//         minutes: m.minutes()
//     }
// }

const parseValue = (value: string | { hours: number, minutes: number }) => {
    if (value) {
        if (typeof value === 'string') {
            const min = value.split(':')[0];
            const hour = value.split(':')[1];
            const dt = moment({ hour: +hour, minute: +min });
            return dt.toDate();
        }
        else {
            const dt = moment({ hour: value.hours, minute: value.minutes });
            return dt.toDate();
        }
    }
    return null;
}
export default withStyles(styles)(TextField);